import {
  Box,
  Dialog,
  DialogContent,
  Fab,
  Paper,
  Tab,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./event_details.css";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import Event1 from "../../../images/event1.jpg";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import axios from "axios";
import getEventController from "../Controller/getEvent_controller.js";
import CircularProgress from "@mui/material/CircularProgress";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Divider } from "antd";
import PPKMLogo from "../../../images/ppkmLogo.jpg";

const EventDetails = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [spacing, setSpacing] = React.useState(2);
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const { eventId } = useParams(); // Get the event ID from URL
  const [eventData, setEventData] = useState(null);
  const [isPastEvent, setIsPastEvent] = useState(false); // Track if the event is in the past

  const [open, setOpen] = useState(false);
  // Function to open the dialog
  const handleClickOpen = () => setOpen(true);
  // Function to close the dialog
  const handleClose = () => setOpen(false);

  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleEventClick = (eventId) => {
    navigate(`/event_payment/${eventId}`);
  };

  // useEffect(() => {
  //   // Fetch events data on component mount
  //   getEventController.getEventDetails({ eventId }).then((response) => {
  //     if (Array.isArray(response)) {
  //       // Map the data into the format expected for each event
  //       const dynamicEvents = response.map((item) => {
  //         const startDate = new Date(item.event_start_datetime);
  //         const endDate = new Date(item.event_end_datetime);

  //         // Format the dates as "DD-MMM-YYYY" (e.g., "12-Jan-2024")
  //         const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  //           day: "2-digit",
  //           month: "short",
  //           year: "numeric",
  //         });

  //         return {
  //           id: item.eventID,
  //           imgSrc: item.event_poster || "No Poster",
  //           title: item.event_name || "Untitled Event",
  //           startdate: item.event_start_datetime
  //             ? dateFormatter.format(startDate)
  //             : "Date not available",
  //           enddate: item.event_end_datetime
  //             ? dateFormatter.format(endDate)
  //             : "Date not available",
  //           venue: item.event_venue || "Venue not specified",
  //         };
  //       });

  //       setEventData(dynamicEvents); // Update the state with formatted events
  //     }
  //   });
  // }, []);

  useEffect(() => {
    getEventController
      .getEventDetails({ eventId })
      .then((response) => {
        if (response) {
          const startDate = new Date(response.event_start_date);
          let endDate = response.event_end_date;

          // Handle the case where endDate is "0000-00-00"
          if (endDate === "0000-00-00") {
            endDate = null; // Or you can set it to currentDate for comparison
          } else {
            endDate = new Date(endDate); // Convert to Date object
          }

          const currentDate = new Date(); // Get current date

          console.log(endDate);
          console.log(currentDate);

          // Format the dates as "DD-MMM-YYYY"
          const dateFormatter = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });

          setEventData({
            id: response.eventID,
            imgSrc: response.event_poster,
            event_file: response.event_file,
            title: response.event_name || "Untitled Event",
            startdate: response.event_start_date
              ? dateFormatter.format(startDate)
              : "Date not available",
            enddate: endDate
              ? dateFormatter.format(endDate)
              : "Date not available", // Handle missing date
            venue: response.event_venue || "Venue not specified",
            description: response.event_desc || "No description available",
            max_pax: response.max_pax || "No limit",
            event_schedules: response.event_schedules || "No schedules",
          });

          // If endDate is null or invalid, treat it as a past event, otherwise compare dates
          setIsPastEvent(!endDate || currentDate > endDate); // Compare Date objects
        }
      })
      .catch((error) => {
        console.error("Error fetching event data:", error);
      });
  }, [eventId]);

  const formatSchedule = (schedule) => {
    const [datePart, timePart] = schedule.split(" ");
    const [startTime, endTime] = timePart.split("-");

    // Convert date to DD/MM/YYYY format
    const formattedDate = new Date(datePart).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return `${formattedDate} | ${startTime} - ${endTime}`;
  };

  if (!eventData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} /> {/* Adjust size as needed */}
      </div>
    );
  }

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="event-details">
          {/*Event Poster Grid*/}
          <div>
            <Grid item xs={12}>
              <Grid
                container
                spacing={spacing}
                sx={{ justifyContent: "center" }}
              >
                <Grid>
                  <img src={eventData.imgSrc} className="icon3" />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={spacing}
                sx={{
                  marginTop: "20px",
                  fontWeight: "bold",
                  fontSize: "22px",
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <Grid>
                  <span>{eventData.title}</span>
                </Grid>
              </Grid>
              <Grid
                container
                direction="column"
                spacing={spacing}
                sx={{
                  marginTop: "10px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  padding: "10px 0px 0px 20px",
                }}
              >
                <Grid>
                  <PinDropIcon className="event-details-icon" />
                  <span>{eventData.venue}</span>
                </Grid>
                <Grid>
                  <CalendarMonthIcon className="event-details-icon" />
                  <span>
                    {eventData.startdate} - {eventData.enddate}
                  </span>
                </Grid>
                <Grid>
                  <ScheduleIcon className="event-details-icon" />
                  <span>8.00 am - 6.00 pm</span>
                </Grid>
                {/* <Grid>
                  <DescriptionOutlinedIcon className="event-details-icon" />
                  <a href="#">Click to download PDF</a>
                </Grid> */}
              </Grid>
              <Grid
                container
                direction="column"
                spacing={spacing}
                sx={{
                  marginTop: "10px",
                  fontWeight: "bold",
                  fontSize: "14px",
                  padding: "20px 0px 0px 20px",
                }}
              >
                <Grid>
                  <span>Details: </span>
                </Grid>
                <Grid>
                  <span>{eventData.description}</span>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div>
            <button
              className="join-button"
              onClick={() => navigate("/event_payment")}
            >
              Join Now
            </button>
          </div>
        </div>
      ) : (
        <div className="event-details">
          {/* Backward button */}
          <div style={{ height: "20px" }}>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
            <span>BACK </span>
          </div>

          {/*Event Poster Grid*/}
          <div style={{ width: "100%" }}>
            <Grid
              container
              spacing={spacing}
              sx={{ justifyContent: "flex-start", marginTop: "20px" }}
            >
              <Divider style={{ borderColor: "black" }} />
              <Grid
                container
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  backgroundColor: "#fff",
                  padding: "20px",
                  // boxShadow: 3,
                  borderRadius: "8px",
                }}
              >
                {/* Image on the Left with click-to-preview functionality */}
                <Grid item sx={{ paddingRight: "20px" }}>
                  <img
                    src={
                      eventData.imgSrc && eventData.imgSrc.trim() !== ""
                        ? eventData.imgSrc
                        : PPKMLogo
                    }
                    className="icon3"
                    onClick={handleClickOpen}
                    style={{
                      width: "250px",
                      height: "300px",
                      cursor: "pointer",
                      borderRadius: "8px",
                    }}
                    alt="Event"
                  />
                </Grid>

                {/* Dialog to preview the image */}
                <Dialog open={open} onClose={handleClose} maxWidth="md">
                  <DialogContent>
                    <img
                      src={eventData.imgSrc}
                      alt="Event Preview"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </DialogContent>
                </Dialog>

                {/* Event Details on the Right in Column Layout */}
                <Grid container item sx={{ flex: 1 }} direction="column">
                  {/* Event Title */}
                  <Grid
                    item
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.875rem",
                      marginBottom: "10px",
                    }}
                  >
                    <span>{eventData.title}</span>
                  </Grid>

                  {/* Venue */}
                  <Grid
                    item
                    sx={{
                      fontSize: "16px",
                      marginBottom: "5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PinDropIcon
                      className="event-details-icon"
                      sx={{ marginRight: "8px" }}
                    />
                    <span>{eventData.venue}</span>
                  </Grid>

                  {/* Date */}
                  <Grid
                    item
                    sx={{
                      fontSize: "16px",
                      marginBottom: "5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <CalendarMonthIcon
                      className="event-details-icon"
                      sx={{ marginRight: "8px" }}
                    />
                    <span>
                      {eventData.startdate} - {eventData.enddate}
                    </span>
                  </Grid>

                  {/* event schedule */}
                  <Grid
                    item
                    sx={{
                      fontSize: "16px",
                      marginBottom: "5px",
                      display: "flex",
                      alignItems: "flex-start", // Align icon with the first line
                    }}
                  >
                    {/* Icon */}
                    <ScheduleIcon
                      sx={{ marginRight: "8px", marginTop: "4px" }}
                    />

                    {/* Schedule List */}
                    <Box>
                      {eventData.event_schedules
                        ? eventData.event_schedules
                            .split(",")
                            .map((schedule, index) => (
                              <Typography key={index} sx={{ display: "block" }}>
                                {formatSchedule(schedule)}
                              </Typography>
                            ))
                        : "No schedules available"}
                    </Box>
                  </Grid>

                  {/* Document Link */}
                  <Grid
                    item
                    sx={{
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DescriptionOutlinedIcon
                      className="event-details-icon"
                      sx={{ marginRight: "8px" }}
                    />
                    {typeof eventData.event_file === "string" &&
                    eventData.event_file.trim() !== "" ? (
                      <a href={eventData.event_file} target="_blank" download>
                        Click to download PDF
                      </a>
                    ) : (
                      <span style={{ color: "gray" }}>No file available</span>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <Divider style={{ borderColor: "black" }} />

          {/* Event Overview */}
          <div>
            <Box sx={{ width: "80%", typography: "body1", marginTop: "20px" }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Overview" value="1" />
                    {/* <Tab label="Item Two" value="2" />
                    <Tab label="Item Three" value="3" /> */}
                  </TabList>
                </Box>
                <TabPanel
                  value="1"
                  sx={{
                    textAlign: "justify",
                  }}
                >
                  {eventData.description}
                </TabPanel>
                {/* <TabPanel value="2">Item Two</TabPanel>
                <TabPanel value="3">Item Three</TabPanel> */}
              </TabContext>
            </Box>
          </div>
          <div>
            {!isPastEvent && (
              <button
                className="join-button"
                onClick={() => handleEventClick(eventData.id)}
              >
                Join Now
              </button>
            )}
          </div>

          {/* <div>
            <span>More Events</span>
          </div> */}
        </div>
      )}
    </React.Fragment>
  );
};

export default EventDetails;
